module.exports = __webpack_public_path__ + "static/media/4.Picture-hardware-facilities.6651cb18.png";